import React from 'react';
import QRCode from 'react-qr-code';

function QrCodeComp({ value, style }) {
  return (
    <QRCode
      size={256}
      style={style || { height: 'auto', maxWidth: '100%', width: '100%' }}
      value={value}
      viewBox="0 0 256 256"
    />
  );
}

export default QrCodeComp;
